import { render, staticRenderFns } from "./DateFlyfood.vue?vue&type=template&id=84abd5da"
import script from "./DateFlyfood.vue?vue&type=script&lang=js"
export * from "./DateFlyfood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports